import {Stack, Button, Typography, Box} from "@mui/material";
import React, { useContext } from "react";
import PersonAddIcon from '@mui/icons-material/PersonAdd';
import BusinessIcon from '@mui/icons-material/Business';
import {isMobile} from "react-device-detect";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { ConfigLinksDetailsContext } from "../../Context/cofingLinksDetailsContext";

const CreateUser = () => {
    const isNotMobile = !isMobile ? {width: "90%", height: "80px", my: 2} : {mx: 2};
    const navigate = useNavigate();
    const { t } = useTranslation();
    const { configLinks } = useContext(ConfigLinksDetailsContext);

    const showCitizen = configLinks?.showCitizenRegistration ?? true;
    const showCompany = configLinks?.showCompanyRegistration ?? true;

    return (
        <Stack sx={{alignItems: "center", height: "100%", justifyContent: "space-between", mt: 3}}>
            <Typography sx={{fontWeight: "bold"}} variant="h5" color="primary.main" mb={3.5}>{t('createUser_title')}</Typography>
            {showCitizen && (
                <Button sx={{...isNotMobile, backgroundColor: "#fff", borderRadius: "18px"}} size="large" variant="outlined" onClick={() => navigate("/sign-up")}>
                    <Stack sx={{width: "100%"}} alignItems="center" direction="row" gap={3}>
                        <Box sx={{display: "flex", background: "#e4e9ef", p: 2, borderRadius: "7px"}}>
                            <PersonAddIcon fontSize="large"/>
                        </Box>
                        <Typography sx={{ width: "100%", fontWeight: "bold"}}>{t('createUser_citizenReg')}</Typography>
                        <Box sx={{width: 80}}></Box>
                    </Stack>
                </Button>
            )}
            {showCompany && (
                <Button sx={{...isNotMobile, backgroundColor: "#fff", borderRadius: "18px"}} size="large" variant="outlined" onClick={() => navigate("/sign-up-company")}>
                    <Stack sx={{width: "100%"}} alignItems="center" direction="row" gap={3}>
                        <Box sx={{display: "flex", background: "#e4e9ef", p: 2, borderRadius: "7px"}}>
                            <BusinessIcon fontSize="large"/>
                        </Box>
                        <Typography sx={{ width: "100%", fontWeight: "bold"}}>{t('createUser_companyReg')}</Typography>
                        <Box sx={{width: 80}}></Box>
                    </Stack>
                </Button>
            )}
            <Box></Box>
            <Box></Box>
        </Stack>
    );
};
export default CreateUser;
